/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { MarkAsResolvedButtonAlertFragmentDoc } from '../MarkAsResolvedButton/markAsResolvedButton.hook'
export type DefaultActionsOpenAlert_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsOpenAlert_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_RoadBlockageTaskNotification_Fragment = {
  __typename?: 'RoadBlockageTaskNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_ShiftDeviationNotification_Fragment = {
  __typename?: 'ShiftDeviationNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_StopAccessibilityDownvotedByDrivers_Fragment =
  {
    __typename?: 'StopAccessibilityDownvotedByDrivers'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsOpenAlert_StopActivationFailedNotification_Fragment =
  {
    __typename?: 'StopActivationFailedNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsOpenAlert_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename?: 'StopAreaMissingActiveStopsNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsOpenAlert_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_StopPotentiallyUnreachable_Fragment = {
  __typename?: 'StopPotentiallyUnreachable'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_TimeManagementNotification_Fragment = {
  __typename?: 'TimeManagementNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_TripPrebookingNoAssignment_Fragment = {
  __typename?: 'TripPrebookingNoAssignment'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_VehicleAvailabilityNotification_Fragment = {
  __typename?: 'VehicleAvailabilityNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_VehicleIncidentNotification_Fragment = {
  __typename?: 'VehicleIncidentNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_VehicleSurveillanceNotification_Fragment = {
  __typename?: 'VehicleSurveillanceNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlert_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsOpenAlertFragment =
  | DefaultActionsOpenAlert_HubServiceNotification_Fragment
  | DefaultActionsOpenAlert_IvcTaskNotification_Fragment
  | DefaultActionsOpenAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | DefaultActionsOpenAlert_PassengerUnbuckled_Fragment
  | DefaultActionsOpenAlert_RoadBlockageTaskNotification_Fragment
  | DefaultActionsOpenAlert_ShiftDeviationNotification_Fragment
  | DefaultActionsOpenAlert_StopAccessibilityDownvotedByDrivers_Fragment
  | DefaultActionsOpenAlert_StopActivationFailedNotification_Fragment
  | DefaultActionsOpenAlert_StopAreaMissingActiveStopsNotification_Fragment
  | DefaultActionsOpenAlert_StopDownVotedByDrivers_Fragment
  | DefaultActionsOpenAlert_StopPotentiallyUnreachable_Fragment
  | DefaultActionsOpenAlert_StopValidationFailed_Fragment
  | DefaultActionsOpenAlert_TimeManagementNotification_Fragment
  | DefaultActionsOpenAlert_TripPrebookingNoAssignment_Fragment
  | DefaultActionsOpenAlert_VehicleAvailabilityNotification_Fragment
  | DefaultActionsOpenAlert_VehicleIncidentNotification_Fragment
  | DefaultActionsOpenAlert_VehicleSurveillanceNotification_Fragment
  | DefaultActionsOpenAlert_VehicleWaypointAttendance_Fragment

export const DefaultActionsOpenAlertFragmentDoc = gql`
    fragment DefaultActionsOpenAlert on TaskNotification {
  ...MarkAsResolvedButtonAlert
}
    ${MarkAsResolvedButtonAlertFragmentDoc}`
